export const CATEGORY_LIST_MAX_HEIGHT = '500px';